var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-settings"},[_c('div',{staticClass:"sidebar-content scrollbar"},[_vm._t("default")],2),_c('div',{staticClass:"sidebar-buttons"},[_vm._t("buttons")],2)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }